import { FormControl } from '@mui/material';
import { SelectChangeEvent } from "@mui/material/Select";

import { MySelect, MyMenuItem } from "~/mui/MySelect";
import { ALL_LANGS } from "~/const";
import { useTrans } from "~/hooks/useTrans";
import { langStore } from "~/stores/lang";
import { loadLanguage } from "~/providers/lang";
import { apiSetGlobalLang } from "~/providers/api";

import FlagCs from "~/assets/flags/flag-cs.svg";
import FlagEn from "~/assets/flags/flag-en.svg";

import "./style.less";

export default function LangSwitcher() {
	const { trans } = useTrans();
	const { curLangKey } = langStore(langState => ({
		curLangKey: langState.data.lang,
	}));

	async function handleChange(event: SelectChangeEvent) {
		const lang = event.target.value;

		await loadLanguage(lang);
		await apiSetGlobalLang(lang);
	}

	return <FormControl size="small" className="langSwitcher">
		<MySelect
			value={curLangKey}
			onChange={handleChange}
			sx={{
				"boxShadow": 'none',
				'.MuiOutlinedInput-notchedOutline': {
					border: 0,
					borderColor: "transparent !important",
				},
				"background": "#fff",
			}}
		>
			<MyMenuItem value={ALL_LANGS.czech}>
				<div className="langSwitcher__menuItem">
					<img src={FlagCs} alt="" />
					<span className="langSwitcher__menuTitle">
						{ trans("langs.czech") }
					</span>
				</div>
			</MyMenuItem>
			<MyMenuItem value={ALL_LANGS.english}>
				<div className="langSwitcher__menuItem">
					<img src={FlagEn} alt="" />
					<span className="langSwitcher__menuTitle">
						{ trans("langs.english") }
					</span>
				</div>
			</MyMenuItem>
		</MySelect>
	</FormControl>;
}
